import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material';

import RemoveIcon from '../../../assets/icons/Remove';
import colors from '../../../constants/colors';

interface RemoveButtonProps extends IconButtonProps {
  iconProps?: SvgIconProps;
}

const RemoveButton = ({ iconProps, sx, ...props }: RemoveButtonProps) => {
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        p: 0,
        fill: colors.csaaOverlayBlack,
        '&:hover': {
          backgroundColor: 'transparent',
          fill: colors.csaaNeutralBorder,
        },
        ...sx,
      }}
    >
      <RemoveIcon
        sx={{
          width: { mobile: 24, tablet: 32 },
          height: { mobile: 24, tablet: 32 },
        }}
        {...iconProps}
      />
    </IconButton>
  );
};

export default RemoveButton;
